<ng-template #modalNotas let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h2>Notas - {{this.descripcion}}</h2>
    <button type="button" class="close" aria-label="Close" (click)="c('Close click'); emit('');">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="card">
      <div class="card-content">
        <div class="card-body">
          <div class="row">
            <div class="col-12">
              <form class="form-bordered" [formGroup]="nota" (submit)="saveOrUpdateRecord()">

                <div class="row" style="justify-content: flex-end; margin-bottom: 2px; margin-top: -20px;">
                  <button type="submit" class="btn btn-success  align-self-end" style="margin-right: 1px;"
                          [disabled]="nota.invalid || this.guardado"><i class="ft-save mr-1"></i>Guardar
                  </button>

                  <button class="btn btn-warning align-self-end mr-2"
                          title="Reiniciar Formulario" type="button"
                          (click)="initForm();">
                    <i class="ft-refresh-ccw"></i>
                  </button>
                </div>

                <!-- Notas -->

                <div class="form-group row">
                  <div class="col-md-12">
                    <div class="position-relative has-icon-left">
                  <textarea class="form-control" placeholder="Escribir aquí..." formControlName="notas"
                            oninput="this.value = this.value.toUpperCase()" style="height: 150px;"></textarea>
                      <div class="form-control-position">
                        <i class="ft-chevron-right"></i>
                      </div>
                    </div>

                    <small *ngIf="validateField('notas','maxlength')" class="text-danger">Máximo 255
                      caracteres</small>

                  </div>
                </div>


              </form>
            </div>




          </div>


        </div>
      </div>

    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-info" (click)="c('Close click'); emit('');">Cerrar</button>
  </div>
</ng-template>
